import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function WelcomeToOurExpertise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="32457" id="hero" className="relative w-full px-3 sm:px-4 pt-3 pb-3">
  <div className="relative mx-auto w-full min-h-[90vh] rounded-[1rem] overflow-hidden">
    {/* Background Image */}
    <img src="https://perfect-duck.10web.cloud/wp-content/uploads/2026/03/40-Bluvit_CoWorkingSpace_05052025_sandraschumann_0078-scaled.jpg" alt="Coworking Space" className="absolute inset-0 w-full h-full object-cover" />

    {/* Subtle Overlay */}
    <div className="absolute inset-0 bg-black/10 z-10" />

    {/* Content */}
    <div ref={ref} className={cn("relative z-20 flex items-end min-h-[90vh] transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
      <div className="max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 pb-16">
        {/* Glass Card */}
        <div className="backdrop-blur-xl bg-white/60 border border-white/40 rounded-2xl p-10 md:p-14 max-w-2xl shadow-2xl">
          <span className="mb-5 inline-block rounded-full bg-[#141414]/10 backdrop-blur-sm border border-[#141414]/10 px-5 py-2 text-sm font-semibold uppercase tracking-widest text-[#141414]">
            Coworking Space
          </span>
          <h1 className="mb-6 text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.05] tracking-tighter text-[#141414]">
            Dein Space.<br />Deine Regeln.
          </h1>
          <p className="mb-8 text-base md:text-lg leading-relaxed text-[#555555] max-w-lg">
            Ein Arbeitsplatz, der sich dir anpasst, nicht umgekehrt. Ob du einen festen Platz brauchst oder nur ab und zu einen Schreibtisch — Coworking Kassel gibt dir genau das Setup, das zu deinem Alltag passt.
          </p>
<Button size="lg" className="h-14 rounded-full bg-[#FF6F61] !px-14 text-base font-semibold text-white shadow-lg transition-all hover:bg-[#FF6F61]/90 hover:shadow-xl hover:-translate-y-0.5" onClick={() => {
              document.getElementById('gallery')?.scrollIntoView({
                behavior: 'smooth'
              });
            }}>
  Space entdecken
</Button>
        </div>
      </div>
    </div>
  </div>
</section>;
}